<button
    data-testid="search-menu"
    class="ap-header__navigation-icon ap-header__navigation-icon--search"
    (click)="searchClicked.emit(searchNavigationItem())"
    [ariaLabel]="searchNavigationItem().ariaLabel ?? searchNavigationItem().label"
>
    <asn-icon name="magnifier" size="large" class="ap-header__magnifier"></asn-icon>
</button>
